import React from 'react';
import DOMPurify from 'dompurify';

function replaceBr(string: string) {
    return string.replace(/&lt;br&gt;/g, '<br/>');
}

const SanitizedHTML: React.FC<{ html: string }> = ({ html }) => {
    return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(replaceBr(html)) }} />;
};

export default SanitizedHTML;
